/* gc-cart.js：購物車頁（A 版 Apple 購物袋式，2026-09-09）。
   1) 標題補「總計 6,130 TWD」；
   2) 數量 ＋／－、直接改數字、移除：改走 /cart/change.js 就地更新，不再整頁重載。
      Focal 主題在購物車頁刻意用整頁跳轉（theme.js 的 _updateFromLink：pageType==="cart" 就 location.href），
      每按一次要重載整頁＋所有 App 腳本，Mars 實測「按加會讀很久」的根因就是這個。
   純前端、不動加車／結帳／發票；整檔刪掉＋拿掉 theme.liquid 那行即完全還原。 */
(function () {
  'use strict';
  function totalText() {
    var el = document.querySelector('.cart__total-container [data-hulkapps-cart-total]') ||
             document.querySelector('.cart__total-container .heading:last-child');
    if (!el) return null;
    var t = el.textContent.replace(/\s+/g, ' ').trim();   // 跟右下角總金額同一種寫法（例：6,130 TWD）
    return /\d/.test(t) ? t : null;
  }
  function applyTitle() {
    var h = document.querySelector('.page-header h1');
    if (!h || !document.querySelector('.cart__recap')) return;
    var v = totalText();
    if (!v) return;
    var s = h.querySelector('.gc-cart-total');
    if (!s) { s = document.createElement('span'); s.className = 'gc-cart-total'; h.appendChild(s); }
    var want = '總計 ' + v;
    if (s.textContent !== want) s.textContent = want;
  }
  var pending = false;
  function schedule() { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; applyTitle(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyTitle); else applyTitle();
  new MutationObserver(schedule).observe(document.documentElement, { subtree: true, childList: true, characterData: true });

  /* ---- 數量就地更新 ---- */
  function sectionId() {
    var c = document.querySelector('.cart');
    var s = c && c.closest('.shopify-section');
    return s ? s.id.replace(/^shopify-section-/, '') : null;
  }
  function swap(sel, doc) {
    var a = document.querySelector(sel), b = doc.querySelector(sel);
    if (a && b) a.replaceWith(b);
  }
  var busy = false;
  function change(link) {
    if (busy) return;
    var u = new URL(link, location.origin), p = u.searchParams;
    var body = { quantity: parseInt(p.get('quantity'), 10) };
    if (p.get('line')) body.line = parseInt(p.get('line'), 10); else if (p.get('id')) body.id = p.get('id'); else { location.href = link; return; }
    if (isNaN(body.quantity) || body.quantity < 0) return;
    var sid = sectionId();
    if (!sid) { location.href = link; return; }              // 認不出區段就照原本整頁跳
    body.sections = [sid];
    busy = true;
    var cart = document.querySelector('.cart');
    if (cart) cart.classList.add('gc-cart--busy');
    // 先把數字換掉讓人知道有按到；金額等 Shopify 算完（含自動折扣）再換，不自己算
    if (body.line) {
      var inp = document.querySelector('.cart .quantity-selector__input[data-line="' + body.line + '"]');
      if (inp && body.quantity > 0) inp.value = String(body.quantity);
    }
    fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        var j = res.j;
        if (!res.ok || !j || !j.sections || !j.sections[sid] || j.item_count === 0) { location.reload(); return; }  // 清空要換成空車畫面，交給整頁
        var doc = new DOMParser().parseFromString(j.sections[sid], 'text/html');
        swap('.cart__content', doc);
        swap('.cart__recap-block', doc);     // 總金額＋整單折扣（折扣碼／點數折抵）＋運費註記一起換
        swap('.shipping-bar', doc);
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: j } }));
        applyTitle();
      })
      .catch(function () { location.reload(); })
      .then(function () { busy = false; if (cart) cart.classList.remove('gc-cart--busy'); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.cart a[href*="/cart/change"]');
    if (!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    change(a.getAttribute('href'));
  }, true);
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!(i instanceof HTMLInputElement) || !i.closest('.cart .quantity-selector') || !i.getAttribute('data-line')) return;
    e.stopImmediatePropagation();
    change('/cart/change?quantity=' + encodeURIComponent(i.value) + '&line=' + i.getAttribute('data-line'));
  }, true);
})();
